import { render, staticRenderFns } from "./imgTips.vue?vue&type=template&id=5b2ba2cc&scoped=true"
import script from "./imgTips.vue?vue&type=script&lang=js"
export * from "./imgTips.vue?vue&type=script&lang=js"
import style0 from "./imgTips.vue?vue&type=style&index=0&id=5b2ba2cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ba2cc",
  null
  
)

export default component.exports